import React from "react";

const Spinner = () => {
  return (
    <div>
      <Spinner animation="border" variant="info" />
    </div>
  );
};

export default Spinner;
